module.exports = __webpack_public_path__ + "img/pf.b6f47989.svg";